module.exports = __webpack_public_path__ + "img/rpicon2.167b0229.png";